import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import { getHomeBorrowerStatementsInfolist } from "../../api/BorrowerApi";
import { getMockHomeBorrowerStatementsInfolist } from "../../api/mock/MockBorrowerApi";
import { formatDataProperties, handleErrorResponse } from "../../Helpers";
import { IHomeBorrowerStatementsObj, IHomeBorrowerStatementsView } from "../interfaces/Borrower";
import "../../styles/borrower/home.scss";
import { IErrorResponse, IProxyUser } from "../interfaces/Global";
import BWHomeViewAllFrame from "./BWHomeViewAllFrame";
import { Icon } from "semantic-ui-react";
import { FeatureFlags } from "../constants/LocalServerConstants";

interface IBWHomeBorrowerStatements {
  isGreaterThanMobile: boolean;
  isGreaterThanTablet: boolean;
  isSidebar: boolean;
  isMessage: boolean;
  setIsMessage: (value: boolean) => React.Dispatch<React.SetStateAction<boolean>>;
  errorResponse: IErrorResponse | undefined; 
  setErrorResponse: (value: boolean) => React.Dispatch<React.SetStateAction<IErrorResponse | undefined>> 
  proxyUser: IProxyUser | undefined;
}

const BWHomeBorrowerStatements = ({...props} : IBWHomeBorrowerStatements) => {
  const [isLoading, setIsLoading] = useState(true as boolean);
  const [homeBorrowerStatementsInfoData, setHomeBorrowerStatementsInfoData] = useState([] as IHomeBorrowerStatementsObj[]);

  const history = useHistory();
  const handleError = useCallback(() => {
    history.push("/error");
  }, [history]);

  const convertToTableFormat = (statements) => {
    const statementsTable = [] as IHomeBorrowerStatementsView[];
    const downloadIcon = <Icon className="action-icon" title="Download" name="download" />;
    statements.forEach(statement => statementsTable.push({
      "loanNumber": statement.loanNumber,
      "project": statement.projectName,
      "statementFor": new Date(statement.effectiveDate).toLocaleDateString(),
      "status": statement.isActive ? "Active" : "Inactive",
      "download": downloadIcon
    }));

    return formatDataProperties(statementsTable, [{field: "loanNumber", action: "rename", name: "Loan #"}, {field: "date", action: "rename", name: "Effective Date"}, {field: "download", action: "rename", name: ""}]);
  };

  const getHomeBorrowerStatementsInfoAysnc = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockHomeBorrowerStatementsInfolist() : await getHomeBorrowerStatementsInfolist(props.proxyUser && props.proxyUser.id);
      if (response && response.ok) {
        props.setIsMessage(false);
        const homeBorrowerStatementsInfolist = await response.json();
        const homeBorrowerStatementsViews = [] as IHomeBorrowerStatementsObj[];
        homeBorrowerStatementsInfolist.forEach((homeBorrowerStatementsInfolistItem) => {
          homeBorrowerStatementsViews.push(homeBorrowerStatementsInfolistItem as IHomeBorrowerStatementsObj);
        });
        
        setHomeBorrowerStatementsInfoData(homeBorrowerStatementsViews.sort((a, b) => new Date(b.effectiveDate).getTime() - new Date(a.effectiveDate).getTime()));
      }
      else {
        await handleErrorResponse(response, props.setIsMessage, props.setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }

    setIsLoading(false);
  };

    return (
      <React.Fragment>
        <BWHomeViewAllFrame 
          isGreaterThanTablet={props.isGreaterThanTablet}
          isSidebar={props.isSidebar}
          isMessage={props.isMessage}
          setIsMessage={props.setIsMessage}
          errorResponse={props.errorResponse}
          setErrorResponse={props.setErrorResponse}
          proxyUser={props.proxyUser}
          isLoading={isLoading}
          breadcrumbsCurrent="Borrower Statements"
          formattedDate={convertToTableFormat(homeBorrowerStatementsInfoData)}
          getApiInfoAsync={getHomeBorrowerStatementsInfoAysnc}
          infolistStyleSwitch={false}
          emptyState={{icon: "list alternate outline", text: "You currently have no borrower statements"}}
          tableSortable={["Loan #", "Project", "Status"]}
        />
      </React.Fragment>
    );
  };
  
export default BWHomeBorrowerStatements;